var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-linear',{staticClass:"my-0",attrs:{"height":4,"value":_vm.value * 100,"color":_vm.theme}})
}
var staticRenderFns = []

export { render, staticRenderFns }